export default __webpack_public_path__ + "static/media/identity.7375930d.png";